export enum FeedbackOption {
  GENERAL,
  PUNCTUALITY,
  DRIVING,
  ROUTE,
  APP
}